export enum CadImportConstants {
  NOT_IMPLEMENTED = 'cadImport/NOT_IMPLEMENTED',
  RESET_STATE = 'cadImport/RESET_STATE',
  SET_CAD_RECORDS_RESPONSE = 'cadImport/SET_CAD_RECORDS_RESPONSE',
  GET_CAD_RECORDS = 'cadImport/GET_CAD_RECORDS',
  IMPORT_CAD_DATA = 'cadImport/IMPORT_CAD_DATA',
  SET_SAVE_CAD_DATA_RESPONSE = 'cadImport/SET_SAVE_CAD_DATA_RESPONSE',
  SET_DISABLE_UNIT_FILTERING_FLAG = 'cadImport/SET_DISABLE_UNIT_FILTERING_FLAG',
  WIPE_CAD_DATA = 'cadImport/WIPE_CAD_DATA',
  SET_USER_CAN_DISABLE_UNIT_FILTER = 'cadImport/SET_USER_CAN_DISABLE_UNIT_FILTER',
  EMD_CODE = 'EMD_CODE',
  HAS_IMPORTED_CAD_DATA = 'cadImport/HAS_IMPORTED_CAD_DATA',
  PRE_CAD_IMPORT = 'cadImport/PRE_CAD_IMPORT',
  REMOVE_IMPORTED_CAD_DATA_POINT = 'cadImport/REMOVE_IMPORTED_CAD_DATA_POINT',
  IFR = 'IFR',
}
